import { useNavigate, useRouter } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

/**
 * Universal Back button — falls back to a sensible route when no history exists
 * (direct landings, new tabs, SSR-first navigation).
 */
export function BackButton({
  fallback = "/",
  className = "",
  label = "Back",
}: {
  fallback?: string;
  className?: string;
  label?: string;
}) {
  const navigate = useNavigate();
  const router = useRouter();

  const handleBack = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      router.history.back();
    } else {
      navigate({ to: fallback });
    }
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      aria-label="Go back to previous page"
      className={`inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.28em] opacity-80 hover:opacity-100 transition-opacity ${className}`}
    >
      <ArrowLeft className="h-3.5 w-3.5" />
      {label}
    </button>
  );
}
